module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/bulb-2-02b7e6f9485cc7e0c196758c6836252d.svg";